import { useAsyncFileDownload } from '@/hooks/use-async-file-download';
import { type FileDownloadType, requestFileDownload } from '@/services/api/downloads';

interface UseAsyncFileExportOptions {
  timeoutMs?: number;
}

interface AsyncFileExport {
  isExporting: boolean;
  requestExport: () => Promise<void>;
}

/**
 * Async server-generated export: POSTs v1/download then downloads the file when the WS fileDownload push
 * lands (the shared listener does the download + toast). Thin wrapper over useAsyncFileDownload.
 */
export const useAsyncFileExport = (type: FileDownloadType, parameters: Record<string, unknown>, options?: UseAsyncFileExportOptions): AsyncFileExport => {
  const { isPending, start } = useAsyncFileDownload({
    request: () => requestFileDownload(type, parameters),
    label: 'export',
    timeoutMs: options?.timeoutMs,
  });

  return { isExporting: isPending, requestExport: start };
};
